import request from "../utils/request";

export function createCert({ source_no, subject }) {
  return request({
    method: "post",
    url: "/biz/cert-subjects",
    data: {
      source_no,
      subject,
    },
  });
}

export function updateCert({ id, subject }) {
  return request({
    method: "put",
    url: `/biz/cert-subjects/${id}`,
    data: {
      subject,
    },
  });
}

/**
 * https://yapi.gaoding.com/project/1717/interface/api/121983
 * @param {{
 *  page_num?: number,
 *  page_size?: number,
 *  source_no?: string,
 *  id?: number
 *  valid?:  CERTSubject["valid"]
 * }} query
 * @returns {Promise<{list?: CERTSubject[], total: number, num: number, size: number}>}
 */
export function getCertList(query = {}) {
  return request({
    method: "get",
    url: "/biz/cert-subjects",
    query,
  });
}
